/* eslint react/jsx-indent: 0 */

import React from 'react'
import * as URLS from 'modules/urls'
import appConfig from 'config'
import {
  isValidRequiredEmail,
  validateMultipleChoice,
  validateOtherGoal,
  validateOtherReferrer,
  validateReferrerName,
  validateSingleChoice,
  validateOtherPlatform,
} from './common/validators'

const getHowManyLeadsQuestion = (label) => ({
  type    :'select',
  name    :'leadQuantity',
  validate:validateSingleChoice,
  label,
  options :[
    { value: '', label: '', disabled: true },
    { value: '20-50', label: '20-50' },
    { value: '50-100', label: '50-100' },
    { value: '100-500', label: '100-500' },
    { value: '500-1000', label: '500-1000' },
    { value: '1000+', label: '1000+' },
  ],
})

const baseHowManyLeadsQuestion = getHowManyLeadsQuestion('How many leads do you need?')

const whenToStartQuestion = {
  type    :'select',
  name    :'whenToStart',
  validate:validateSingleChoice,
  label   :'When do you want to get started?',
  options :[
    { value: '', label: '', disabled: true },
    { value: 'asap', label: 'ASAP' },
    { value: 'soon', label: 'In 2 weeks' },
  ],
}

const goalsSection = {
  title :'Get ready to join forces!',
  inputs:[{
    type    :'choices',
    multiple:true,
    name    :'leadPriorities',
    label   :'What are your goals this quarter? (Select all that apply)',
    validate:validateMultipleChoice,
    options :[{
      value:'acquire-new-customers',
      label:'Acquire new customers',
    }, {
      value:'raise-funding',
      label:'Raise funding',
    }, {
      value:'recruit-top-talent',
      label:'Recruit top talent',
    }, {
      value:'improve-operational-efficiency',
      label:'Improve operational efficiency',
    },
    {
      value:'increase-brand-awareness',
      label:'Increase brand awareness',
    }, {
      value:'understand-the-market',
      label:'Understand the market',
    }, {
      value:'increase-your-brand-awareness',
      label:'Increase brand awareness',
    }, {
      value:'other',
      label:'Other',
    }],
  }, {
    name     :'otherLeadPriorities',
    type     :'text',
    label    :'Describe your goal',
    condition:(values) => values.leadPriorities.includes('other'),
    validate :validateOtherGoal,
  }, {
    ...whenToStartQuestion,
  },
  ],
  hideBack              :true,
  mobileBottomBannerText:(
    <>
      Interested in&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>working as an AI Trainer?</a>
    </>
  ),
  desktopBottomBannerText:(
    <>
      If you&apos;re interested in working as an AI Trainer,
      please apply to join our&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>AI projects community.</a>
    </>
  ),
}
const contactInfoSection = {
  save    :true,
  title   :'Let\'s get to work! How do we contact you?',
  posttext:<>
    <p>
      Already set up?
      {' '}
      <a href={`mailto:${appConfig.SITE.SUPPORT_EMAIL}`}>Message your project manager</a>
      .
    </p>
    <p>
      By continuing, you agree to receive communications
      from Pareto and authorize us to process your personal information
      in compliance with our
      {' '}
      <a href="/privacy">privacy policy</a>
      .
    </p>
           </>,
  inputs:[{
    type     :'text',
    name     :'email',
    label    :'Email',
    validate :isValidRequiredEmail,
    className:'email-validation-height',
  }],
  mobileBottomBannerText:(
    <>
      Interested in&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>working as an AI Trainer?</a>
    </>
  ),
  desktopBottomBannerText:(
    <>
      If you&apos;re interested in working as an AI Trainer,
      please apply to join our&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>AI projects community.</a>
    </>
  ),
}

const budgetSection = {
  save  :true,
  title :'How did you hear about us?',
  inputs:[{
    type    :'select',
    name    :'preferredContactMode',
    label   :'Which platform do you primarily work from?',
    validate:validateSingleChoice,
    options :[
      { value: '', label: '', disabled: true },
      { value: 'email', label: 'Email' },
      { value: 'slack', label: 'Slack' },
      { value: 'discord', label: 'Discord' },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    type     :'text',
    name     :'otherPreferredContactMode',
    label    :'Please share your platform details.',
    validate :validateOtherPlatform,
    condition:(values) => values.preferredContactMode === 'other',
  },
  {
    type    :'select',
    name    :'leadBudget',
    label   :'What is your annual ops budget?',
    validate:validateSingleChoice,
    options :[
      { value: '', label: '', disabled: true },
      { value: '<$10k', label: '<$10k' },
      { value: '$10-$100k', label: '$10-$100k' },
      { value: '$100-$500k', label: '$100-$500k' },
      { value: '$500k-$1M', label: '$500k-$1M' },
      { value: '1M+', label: '1M+' },
    ],
  }, {
    type    :'select',
    name    :'leadSource',
    label   :'How did you hear about us?',
    validate:validateSingleChoice,
    options :[
      { value: '', label: '', disabled: true },
      { value: 'referral', label: 'Referral' },
      { value: 'google', label: 'Google' },
      { value: 'linkedIn', label: 'LinkedIn' },
      { value: 'twitter', label: 'Twitter' },
      { value: 'instagram', label: 'Instagram' },
      { value: 'facebook', label: 'Facebook' },
      { value: 'reddit', label: 'Reddit' },
      { value: 'blog', label: 'Blog post' },
      { value: 'podcast', label: 'Podcast' },
      { value: 'event', label: 'Event' },
      { value: 'email', label: 'Email' },
      { value: 'other', label: 'Other' },
    ],
  }, {
    name     :'otherReferrer',
    type     :'text',
    label    :"Referrer's full name",
    validate :validateReferrerName,
    condition:(values) => values.leadSource === 'referral',
  },
  {
    name     :'otherLeadSource',
    type     :'text',
    label    :'Please share how you found us.',
    validate :validateOtherReferrer,
    condition:(values) => values.leadSource === 'other',
  }],
}

const aiBudgetSection = {
  save  :true,
  inputs:[{
    type    :'select',
    name    :'preferredContactMode',
    label   :'Which platform do you primarily work from?',
    validate:validateSingleChoice,
    options :[
      { value: '', label: '', disabled: true },
      { value: 'email', label: 'Email' },
      { value: 'slack', label: 'Slack' },
      { value: 'discord', label: 'Discord' },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    type     :'text',
    name     :'otherPreferredContactMode',
    label    :'Please share your platform details.',
    validate :validateOtherPlatform,
    condition:(values) => values.preferredContactMode === 'other',
  },
  {
    type    :'select',
    name    :'leadBudget',
    label   :'What is your annual data budget?',
    validate:validateSingleChoice,
    options :[
      { value: '', label: '', disabled: true },
      { value: '<$10k', label: '<$10k' },
      { value: '$10-$100k', label: '$10-$100k' },
      { value: '$100-$500k', label: '$100-$500k' },
      { value: '$500k-$1M', label: '$500k-$1M' },
      { value: '1M+', label: '1M+' },
    ],
  }, {
    type    :'select',
    name    :'leadSource',
    label   :'How did you hear about us?',
    validate:validateSingleChoice,
    options :[
      { value: '', label: '', disabled: true },
      { value: 'referral', label: 'Referral' },
      { value: 'google', label: 'Google' },
      { value: 'linkedIn', label: 'LinkedIn' },
      { value: 'twitter', label: 'Twitter' },
      { value: 'instagram', label: 'Instagram' },
      { value: 'facebook', label: 'Facebook' },
      { value: 'reddit', label: 'Reddit' },
      { value: 'blog', label: 'Blog post' },
      { value: 'podcast', label: 'Podcast' },
      { value: 'event', label: 'Event' },
      { value: 'email', label: 'Email' },
      { value: 'other', label: 'Other' },
    ],
  }, {
    name     :'otherReferrer',
    type     :'text',
    label    :"Referrer's full name",
    validate :validateReferrerName,
    condition:(values) => values.leadSource === 'referral',
  },
  {
    name     :'otherLeadSource',
    type     :'text',
    label    :'Please share how you found us.',
    validate :validateOtherReferrer,
    condition:(values) => values.leadSource === 'other',
  }],
}

const informationSection = {
  hideBack:true,
  hideNext:true,
  Content :() => (
    <div className="centered-column vertical-flex span-grid">
      <p className="h1 text-gradient x-highlighted remove-margin">Welcome to Pareto!</p>
      <p>
        Welcome to Pareto! We&apos;re excited to get started.
        Look out for an onboarding email in the next 24 hours.
      </p>
    </div>
  ),
}

const startProjectSection = {
  title :'Start your project today.',
  inputs:[{
    ...baseHowManyLeadsQuestion,
  }, {
    ...whenToStartQuestion,
  }],
  hideBack              :true,
  mobileBottomBannerText:(
    <>
      Interested in&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>working as an AI Trainer?</a>
    </>
  ),
  desktopBottomBannerText:(
    <>
      If you&apos;re interested in working as an AI Trainer,
      please apply to join our&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>AI projects community.</a>
    </>
  ),
}

const aiGoalsSection = {
  title :'Get ready to join forces!',
  inputs:[
    {
      type    :'choices',
      multiple:'true',
      name    :'leadPriorities',
      label   :'What are your goals this quarter? (Select all that apply)',
      validate:validateMultipleChoice,
      options :[
        {
          value:'reinforcement-learning',
          label:'Reinforcement Learning',
        },
        {
          value:'safety-ethics-compliance',
          label:'Safety, Ethics, & Compliance Training',
        },
        {
          value:'data-labeling',
          label:'Data Labelling',
        },
        {
          value:'engine-annotation',
          label:'Engine Annotation',
        },
        {
          value:'model-evaluation',
          label:'Model Evaluation',
        },
        {
          value:'domain-specific-training',
          label:'Domain Specific Training',
        },
        {
          value:'other',
          label:'Other',
        },
      ],
    },
    {
      name     :'otherLeadPriorities',
      type     :'text',
      label    :'Describe your goal',
      condition:(values) => values.leadPriorities.includes('other'),
      validate :validateOtherGoal,
    },
    whenToStartQuestion,
  ],
  hideBack              :true,
  mobileBottomBannerText:(
    <>
      Interested in&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>working as an AI Trainer?</a>
    </>
  ),
  desktopBottomBannerText:(
    <>
      If you&apos;re interested in working as an AI Trainer,
      please apply to join our&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>AI projects community.</a>
    </>
  ),
}

const useCaseInitialSection = {
  title   :'Get ready to join forces!',
  posttext:<>
    <p>
      Already set up?
      {' '}
      <a href={`mailto:${appConfig.SITE.SUPPORT_EMAIL}`}>Message your project manager</a>
      .
    </p>
    <p>
      By continuing, you agree to receive communications
      from Pareto and authorize us to process your personal information
      in compliance with our
      {' '}
      <a href="/privacy">privacy policy</a>
      .
    </p>
           </>,
  inputs:[
    whenToStartQuestion,
    {
      type     :'text',
      name     :'email',
      label    :'Email',
      validate :isValidRequiredEmail,
      className:'email-validation-height',
    },
  ],
  hideBack              :true,
  save                  :true,
  mobileBottomBannerText:(
    <>
      Interested in&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>working as an AI Trainer?</a>
    </>
  ),
  desktopBottomBannerText:(
    <>
      If you&apos;re interested in working as an AI Trainer,
      please apply to join our&nbsp;
      <a href={URLS.SITE.AI_TRAINER}>AI projects community.</a>
    </>
  ),
}

const projectSection = {
  title :'Last but not least! What are you hoping to accomplish with Pareto?',
  inputs:[
    {
      type :'textarea',
      name :'leadDescription',
      label:'Describe any project ideas or task examples to help us get started faster.',
    },
  ],
  save:true,
}

const aiExpertSection = {
  inputs:[
    {
      type      :'expertForm',
      extraTypes:{
        expertForm:() => (
          <iframe
            src="https://paretoai.typeform.com/ai-trainer"
            allow="fullscreen"
            title="Pareto AI Trainer Form"
          />
        ),
      },
    },
  ],
}

export const generateSolutionsSectionMap = (firstSlideTitle, firstQuestionText) => {
  const firstSlide = {
    title :firstSlideTitle,
    inputs:[{
      ...getHowManyLeadsQuestion(firstQuestionText),
    }, {
      ...whenToStartQuestion,
    }],
    hideBack              :true,
    mobileBottomBannerText:(
      <>
        Interested in&nbsp;
        <a href={URLS.SITE.AI_TRAINER}>working as an AI Trainer?</a>
      </>
    ),
    desktopBottomBannerText:(
      <>
        If you&apos;re interested in working as an AI Trainer,
        please apply to join our&nbsp;
        <a href={URLS.SITE.AI_TRAINER}>AI projects community.</a>
      </>
    ),
  }

  return [
    firstSlide,
    contactInfoSection,
    budgetSection,
    projectSection,
    informationSection,
  ]
}

export const solutionsSectionMap = [
  startProjectSection,
  contactInfoSection,
  budgetSection,
  projectSection,
  informationSection,
]

const commonSectionMap = [
  goalsSection,
  contactInfoSection,
  budgetSection,
  projectSection,
  informationSection,
]

export const aiSectionMap = [
  aiGoalsSection,
  contactInfoSection,
  aiBudgetSection,
  projectSection,
  informationSection,
]

export const useCaseSectionMap = [
  useCaseInitialSection,
  aiBudgetSection,
  projectSection,
  informationSection,
]

export const aiExpertSectionMap = [
  aiExpertSection,
]

export default commonSectionMap
